import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Box, Button, Checkbox } from '@chakra-ui/react';
import { Modal, Textarea } from 'shared-components';
import { closeModal } from '../../../../store/ui/actions';
import { ApplicationState } from '../../../../store';
import { IProps } from './types';
import React, { useState } from 'react';
import { IMessage } from 'types';
import { UNI_ROLES, ENROLY_AGENT_ROLES, AGENT_ROLES } from '../../../../store/auth/types';
import { saveMessage } from '../../../../store/student/actions';
import getPropsFromState from './utils/getPropsFromState';
import { rescindRejectDoc } from '../../../../store/student/documents/actions';
import { rescindRejectDoc as rescindRejectFinDoc } from '../../../../store/student/financeDocuments/actions';
import { rescindRejectDoc as rescindRejectFollowUpDoc } from '../../../../store/student/followUpDocuments/actions';

const initialMessage: IMessage = {
  message: '',
  isSendToStudent: true,
  messageType: 'note',
  createdAt: 0,
  author: '',
  authorName: '',
  messageFrom: 'uni',
  messageTo: 'student',
};

export default function FileRescindRejectionModal() {
  const dispatch = useDispatch();
  const {
    prevStatus,
    sponsorType,
    docType,
    sponsorKey,
    docKey = null,
    modalTitle = '',
    userName,
    displayName,
    docUserAccess,
    isFinanceDocumentModal,
    isFollowUpDocumentModal,
    role,
  }: IProps = useSelector((state: ApplicationState) => getPropsFromState(state), shallowEqual);

  const [message, setMessage] = useState(initialMessage);
  const [isSendToStudent, setIsSendToStudent] = useState(true);
  const handleModalClose = () => dispatch(closeModal());

  const submitMessage = () => {
    const author = userName || 'Anonymous';
    const msgTitle = modalTitle;
    const msgReason = message.message ? `Rejected: ${message.message}` : 'Rejected';

    const newMessage: IMessage = {
      message: `${msgTitle} ${msgReason}`,
      createdAt: Date.now(),
      isSendToStudent: !docUserAccess && isSendToStudent,
      messageType: 'note',
      author,
      authorName: displayName || author,
      messageFrom: 'uni',
      messageTo: !docUserAccess && isSendToStudent ? 'student' : 'uni',
      ...(UNI_ROLES.includes(role) ? { uniRead: true } : {}),
      ...(ENROLY_AGENT_ROLES.includes(role) ? { adminRead: true } : {}),
      ...(AGENT_ROLES.includes(role) ? { agentRead: true } : {}),
    };

    if (isFinanceDocumentModal) {
      dispatch(rescindRejectFinDoc(sponsorType, sponsorKey, docType, docKey, prevStatus, newMessage.message || ''));
    } else if (isFollowUpDocumentModal) {
      dispatch(
        rescindRejectFollowUpDoc(sponsorType, sponsorKey, docType, docKey, prevStatus, newMessage.message || ''),
      );
    } else {
      dispatch(rescindRejectDoc(sponsorType, sponsorKey, docType, docKey, prevStatus, newMessage.message || ''));
    }

    dispatch(saveMessage(newMessage));

    handleModalClose();
  };

  return (
    <Modal
      id="file-rescind-rejection"
      show={true}
      title="Rescind document rejection"
      onClose={handleModalClose}
      footer={<ModalFooter submitMessage={submitMessage} />}
    >
      <Textarea
        id={'message'}
        label={'Message'}
        value={message.message}
        onChange={(event: React.FormEvent<HTMLTextAreaElement>) =>
          setMessage({ ...message, message: event.currentTarget.value })
        }
        placeholder={'Type your message here...'}
      />

      {!docUserAccess && (
        <Box>
          <Checkbox
            id={'reject-doc-send-msg-to-student'}
            key={'reject-doc-send-msg-to-student'}
            isChecked={isSendToStudent}
            onChange={() => setIsSendToStudent(!isSendToStudent)}
            size="lg"
          >
            Send this note to student
          </Checkbox>
        </Box>
      )}
    </Modal>
  );
}

const ModalFooter = ({ submitMessage }: { submitMessage: () => void }) => (
  <Button id="submit-log-button" onClick={submitMessage} variant="solid" size="lg">
    Submit
  </Button>
);
